import { db } from '../lib/firebase';
import { collection, doc, setDoc, onSnapshot, getDocs, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';

export interface CartItem {
  listingId: string;
  sellerId: string;
  title: string;
  price: number;
  image?: string;
  quantity: number;
  sellerName?: string;
  metadata?: Record<string, any>;
}

export function subscribeCart(userId: string, cb: (items: CartItem[]) => void) {
  const itemsCol = collection(db, 'carts', userId, 'items');
  return onSnapshot(itemsCol, (snap) => {
    const items: CartItem[] = snap.docs.map((d) => ({ ...(d.data() as any) })) as CartItem[];
    cb(items);
  });
}

export async function getCartItems(userId: string): Promise<CartItem[]> {
  const itemsCol = collection(db, 'carts', userId, 'items');
  const snap = await getDocs(itemsCol);
  return snap.docs.map((d) => ({ ...(d.data() as any) })) as CartItem[];
}

export async function addCartItem(userId: string, item: Omit<CartItem, 'quantity'>, quantity: number = 1) {
  const itemRef = doc(db, 'carts', userId, 'items', item.listingId);
  await setDoc(itemRef, { ...item, quantity, metadata: item.metadata ?? null, addedAt: serverTimestamp() }, { merge: true });
}

export async function updateCartItemQuantity(userId: string, listingId: string, quantity: number) {
  const itemRef = doc(db, 'carts', userId, 'items', listingId);
  if (quantity <= 0) {
    await deleteDoc(itemRef);
    return;
  }
  await updateDoc(itemRef, { quantity });
}

export async function removeCartItem(userId: string, listingId: string) {
  const itemRef = doc(db, 'carts', userId, 'items', listingId);
  await deleteDoc(itemRef);
}

export async function clearUserCart(userId: string) {
  const itemsCol = collection(db, 'carts', userId, 'items');
  const snap = await getDocs(itemsCol);
  const deletions = snap.docs.map((d) => deleteDoc(d.ref));
  await Promise.all(deletions);
}